module.exports = __webpack_public_path__ + "img/id-verifing.b5453a0f.jpg";